import axios from "axios";
import { useEffect, useState } from "react";
import styles from "./AgentAssignComponent.module.css";

const AgentAssignComponent = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [agents, setAgents] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedAgent, setSelectedAgent] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(5);
  const token = localStorage.getItem("token");

  // Fetch campaigns, agents, and assigned campaigns
  useEffect(() => {
    // Fetch campaigns
    axios
      .get(
        "https://prod.toxboxai.com/api/campaign/assigned-campaigns",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setCampaigns(response.data.data.campaigns);
      })
      .catch((error) => console.error("Error fetching campaigns:", error));

    // Fetch agents
    axios
      .get(
        "https://prod.toxboxai.com/api/agent-creation/all",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => setAgents(response.data.agents))
      .catch((error) => console.error("Error fetching agents:", error));

    // Fetch assigned campaigns
    fetchAssignments();
  }, [token, currentPage]);

  const fetchAssignments = () => {
    axios
      .get(
        "https://prod.toxboxai.com/api/campaign/assigned-campaigns-with-agents",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setAssignments(response.data.data);
        const total = Math.ceil(response.data.count / itemsPerPage);
        setTotalPages(total || 1);
      })
      .catch((error) =>
        console.error("Error fetching assigned campaigns:", error)
      );
  };

  const handleAssign = () => {
    if (selectedCampaign && selectedAgent) {
      const payload = {
        campaignId: selectedCampaign,
        agentId: selectedAgent,
      };

      axios
        .post(
          "https://prod.toxboxai.com/api/campaign/assign-agent",
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          console.log("Assignment successful:", response.data);
          setSelectedCampaign("");
          setSelectedAgent("");
          fetchAssignments(); // Refresh assignments
        })
        .catch((error) => console.error("Error assigning agent:", error));
    }
  };

  const handleUnassign = (campaignId) => {
    axios
      .post(
        "https://prod.toxboxai.com/api/campaign/unassign-agent",
        { campaignId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        console.log("Unassignment successful:", response.data);
        fetchAssignments(); // Refresh assignments
      })
      .catch((error) => console.error("Error unassigning agent:", error));
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Calculate assignments to display for current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentAssignments = assignments.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Generate page numbers for pagination
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Assign Campaign to Agent</h2>
      <div className={styles.selectWrapper}>
        <select
          value={selectedCampaign}
          onChange={(e) => setSelectedCampaign(e.target.value)}
          className={styles.select}
        >
          <option value="">Select Campaign</option>
          {campaigns.map((campaign) => (
            <option key={campaign._id} value={campaign._id}>
              {campaign.campaignname || "Unnamed Campaign"}
            </option>
          ))}
        </select>
        <select
          value={selectedAgent}
          onChange={(e) => setSelectedAgent(e.target.value)}
          className={styles.select}
        >
          <option value="">Select Agent</option>
          {agents.map((agent) => (
            <option key={agent._id} value={agent._id}>
              {agent.avatarName || "Unnamed Agent"}
            </option>
          ))}
        </select>
        <button
          onClick={handleAssign}
          className={styles.button}
          disabled={!selectedCampaign || !selectedAgent}
        >
          Assign
        </button>
      </div>

      <section className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Campaign</th>
              {/* <th>Agent</th>
            <th>Project</th> */}
              <th>Campaign Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentAssignments.map((assignment) => (
              <tr key={assignment._id}>
                <td>{assignment.campaignname}</td>
                {/* <td>{assignment.assignedAgent?.avatarName || "N/A"}</td>
              <td>
                {assignment.assignedAgent?.systemPrompt?.promptName || "N/A"}
              </td> */}
                <td>{assignment.campaignStatus}</td>
                <td>
                  {assignment.assignedAgent ? (
                    <button
                      onClick={() => handleUnassign(assignment._id)}
                      className={`${styles.unassignedbutton} ${styles.unassignButton}`}
                    >
                      Unassign
                    </button>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <div className={styles.pagination}>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={styles.pageButton}
        >
          Previous
        </button>
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={`${styles.pageButton} ${currentPage === page ? styles.active : ""
              }`}
          >
            {page}
          </button>
        ))}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={styles.pageButton}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AgentAssignComponent;
